import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { Message } from 'element-ui'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import request from './utils/request'

// 注册全局路由安全跳转mixin
import routerSafeMixin from './mixins/router-safe'
Vue.mixin(routerSafeMixin)

// 富文本编辑器：统一使用 WangEditor（与 admin 端一致）
import WangEditor from './components/WangEditor'
Vue.component('WangEditor', WangEditor)

Vue.config.productionTip = false

// Element UI全量引入
Vue.use(ElementUI)

// 配置全局HTTP请求
Vue.prototype.$http = request

// 配置全局消息提示
Vue.prototype.$message = function(options) {
  return Message(options);
};
Vue.prototype.$message.success = function (message) {
  return Message.success({
    message,
    showClose: true
  });
};
Vue.prototype.$message.info = function (message) {
  return Message.info({
    message,
    showClose: true
  });
};
Vue.prototype.$message.error = function (message) {
  return Message.error({
    message,
    showClose: true
  });
};
Vue.prototype.$message.warning = function (message) {
  return Message.warning({
    message,
    showClose: true
  });
};

// 注册全局过滤器
import { formatDate } from './utils/index'
Vue.filter('formatDate', formatDate)

// 初始化跨应用登录状态同步
import AuthSync from './utils/auth-sync'
const authSync = new AuthSync(store, 'merchant')
store.commit('SET_AUTH_SYNC', authSync)

// 应用启动时自动同步用户信息（解决刷新后状态丢失）
// 只在有token时才同步，避免在登录页面时不必要的请求
// 立即恢复token到store，然后异步同步用户信息
const token = localStorage.getItem('token')
if (token) {
  // 立即恢复token到store，确保请求拦截器能获取到token
  store.commit('auth/SET_TOKEN', token)
  
  // 异步同步用户信息，不阻塞页面渲染
  // 使用Promise.resolve().then()确保在下一个事件循环中执行
  Promise.resolve().then(() => {
    store.dispatch('auth/syncUser').catch(error => {
      // 静默处理所有错误，避免影响页面加载
      // 401错误可能是token过期，由syncUser内部处理
      if (error.response?.status !== 401) {
        console.error('用户信息同步失败:', error)
      }
    })
  })
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

